<!-- 酒店实时订单：完整列表 POST /manager/listType2OrdersWithDetails；轮询 POST /manager/listType2OrdersLightSales -->
<template>
  <el-container class="home-container">
    <el-header>
      <div>
        <span>畅游景德镇管理系统</span>
      </div>
      <h6>{{ userName }}, 你好</h6>
      <el-button type="info" @click="logout">退出</el-button>
    </el-header>
    <el-container>
      <el-aside width="200px">
        <div class="toggle-button">|||</div>
        <el-menu
          :default-active="activeMenu"
          background-color="#333744"
          text-color="#fff"
          active-text-color="#409eff"
          :router="true"
        >
          <el-menu-item
            v-for="menu in menuList"
            :key="menu.ID"
            :index="resolvePath(menu.菜单路由)"
            @click="saveNavState(menu.菜单路由)"
          >
            <i :class="menu.菜单图标"></i>
            <span>{{ menu.菜单名称 }}</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main>
        <div class="hotel-realtime-order">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>实时订单</el-breadcrumb-item>
          </el-breadcrumb>

          <el-alert
            v-if="pollEnabled"
            class="poll-hint"
            type="info"
            :closable="false"
            show-icon
            :title="pollHintTitle"
          />

          <el-card class="main-card">
            <el-row :gutter="12">
              <el-col :span="4">
                <el-input
                  placeholder="请输入手机号"
                  clearable
                  v-model="queryInfo.phone"
                  class="input-with-select"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="getOrderList"
                  ></el-button>
                </el-input>
              </el-col>
              <el-col :span="4">
                <el-input
                  placeholder="请输入订单号"
                  clearable
                  v-model="queryInfo.orderNo"
                  class="input-with-select"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="getOrderList"
                  ></el-button>
                </el-input>
              </el-col>
              <el-col :span="4">
                <el-date-picker
                  type="date"
                  placeholder="选择起始日期"
                  v-model="queryInfo.startTime"
                  @change="getOrderList"
                ></el-date-picker>
              </el-col>
              <el-col :span="4">
                <el-date-picker
                  type="date"
                  placeholder="选择截止日期"
                  v-model="queryInfo.endTime"
                  @change="getOrderList"
                ></el-date-picker>
              </el-col>
              <el-col :span="4">
                <el-select
                  v-model="queryInfo.status"
                  clearable
                  placeholder="订单状态"
                  @change="getOrderList"
                >
                  <el-option
                    v-for="item in statusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row :gutter="12" class="search-actions">
              <el-col :span="4">
                <el-button type="primary" icon="el-icon-search" @click="getOrderList">查询</el-button>
                <el-switch
                  v-model="pollEnabled"
                  active-text="自动刷新"
                  inactive-text="暂停"
                  @change="onPollToggle"
                />
              </el-col>
            </el-row>

            <el-table
              :data="orderList"
              border
              stripe
              v-loading="table_loading"
              :row-class-name="tableRowClassName"
            >
              <el-table-column label="订单号" prop="订单号" width="120"></el-table-column>
              <el-table-column label="房型" prop="名称" min-width="120" show-overflow-tooltip></el-table-column>
              <el-table-column label="购买时间" width="130" prop="购买时间"></el-table-column>
              <el-table-column label="入住时间" width="150" prop="省">
                <template slot-scope="scope">
                  入住：{{scope.row["起始时间"]}}
                  离店：{{scope.row["结束时间"]}}
                </template>
              </el-table-column>
              <el-table-column label="用户信息" width="120">
                <template slot-scope="scope">
                  <div>{{ scope.row["手机号"] || "" }}</div>
                  {{ scope.row["联系人"] || "匿名" }}
                </template>
              </el-table-column>
              <!-- <el-table-column label="数量" prop="数量" width="80">
                <template slot-scope="scope">
                  <span v-if="scope.row['使用状态'] == '已退款'">0</span>
                  <span v-else
                    >{{ scope.row["数量"] - scope.row["cancel_num"] || 0 }}单|{{
                      scope.row["座位数"]
                    }}张</span
                  >
                </template>
              </el-table-column> -->
              <el-table-column label="使用状态" prop="使用状态" min-width="110" align="center">
                <template slot-scope="scope">
                  <el-tag
                    size="small"
                    :type="hotelUseStatusTagType(scope.row)"
                    :effect="hotelUseStatusTagEffect(scope.row)"
                    :class="hotelUseStatusTagClass(scope.row)"
                  >
                    {{ formatHotelUseStatus(scope.row['使用状态']) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="价格" prop="价格">
                <template slot-scope="scope">
                  <span v-if="isHotelRefundedRow(scope.row)">0</span>
                  <span v-else>{{ scope.row["价格"] }}</span>
                </template>
              </el-table-column>
              <el-table-column label="支付方式" prop="订单来源">
                <template slot-scope="scope">
                  {{ scope.row["订单来源"] | getPayType(scope.row["支付方式"]) }}
                </template>
              </el-table-column>
              <el-table-column label="备注" prop="FailReason" min-width="100" show-overflow-tooltip></el-table-column>
              <el-table-column label="操作" min-width="240" fixed="right" v-if="cooperType != '6'">
                <template slot-scope="scope">
                  <span class="hotel-order-actions">
                    <template v-if="hotelUseStatusNorm(scope.row['使用状态']) === '5'">
                      <el-button type="success" size="mini" @click="hotelOrderConfirm(scope.row)">确认</el-button>
                      <el-button type="warning" size="mini" @click="hotelOrderRefund(scope.row)">退款</el-button>
                    </template>
                    <template v-else-if="isRefundAwaitContact(scope.row)">
                      <el-button type="primary" size="mini" @click="hotelOrderAcknowledge(scope.row)">知晓</el-button>
                    </template>
                    <el-button type="info" size="mini" @click="addNote(scope.row)">备注</el-button>
                  </span>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="queryInfo.currentPage"
              :page-size="queryInfo.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </el-card>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import DateFormat from '@/utils/DateFormat.js'
import { isHotelCooperator } from '@/utils/hotelMerchant'

/** 完整列表查询 */
const HOTEL_ORDER_LIST_PATH = '/manager/listType2OrdersWithDetails'
/** 定时轮询（轻量） */
const HOTEL_ORDER_POLL_PATH = '/manager/listType2OrdersLightSales'
const POLL_MS = 60000

/**
 * 确认 / 知晓 / 退款：同一接口 POST /manager/updateOrderStatus
 * - 确认：{ ID, useStatus: 1, FailReason? }
 * - 知晓：{ ID, contactStatus: 1, FailReason? }
 * - 退款：{ ID, useStatusRaw: 3, FailReason? }
 */
const HOTEL_ORDER_UPDATE_STATUS_URL = '/manager/updateOrderStatus'

/** 酒店订单使用状态：接口数值 → 展示文案 */
const HOTEL_USE_STATUS_LABEL = {
  1: '已付款',
  2: '已入住',
  3: '已退款',
  4: '退款中',
  5: '待确认',
}

export default {
  name: 'HotelRealtimeOrder',
  data() {
    return {
      menuList: [
        { ID: 1, 菜单名称: '房型管理', 菜单图标: 'el-icon-s-home', 菜单路由: '/hotelRoomType' },
        { ID: 2, 菜单名称: '实时订单', 菜单图标: 'el-icon-s-order', 菜单路由: '/hotelRealtimeOrder' },
      ],
      userName: window.sessionStorage.getItem('userName') || '',
      pollEnabled: true,
      pollTimer: null,
      /** 曾出现过的订单主键：用于判断「本轮首次出现的待确认(5)」 */
      seenOrderIds: new Set(),
      pollBaselineReady: false,
      queryInfo: {
        searchStr: '',
        currentPage: 1,
        pageSize: 10,
        status: '',
        startTime: '',
        endTime: '',
        orderType: '',
        orderNo: '',
        area_info: { area_name: '', row: '', col: '' },
        phone: '',
      },
      table_loading: false,
      total: 0,
      orderList: [],
      statusOptions: [
        { value: '1', label: '已付款' },
        { value: '2', label: '已入住' },
        { value: '3', label: '已退款' },
        { value: '4', label: '退款中' },
        { value: '5', label: '待确认' },
      ],
      cooperType: window.sessionStorage.getItem('cooperType') || 0,
    }
  },
  computed: {
    activeMenu() {
      return this.$route.path || '/hotelRealtimeOrder'
    },
    pollHintTitle() {
      return '每分钟自动刷新（/manager/listType2OrdersLightSales）：已退款(3)且联系状态为 0 置顶红底；待确认(5)置顶黄底；本轮首次出现的待确认为浅蓝底。'
    },
  },
  created() {
    if (!isHotelCooperator()) {
      this.$message.warning('当前账号非酒店商家，无法访问')
      this.$router.replace('/message/count')
      return
    }
    window.sessionStorage.setItem('activePath', '/hotelRealtimeOrder')
    this.getOrderList()
    this.startPoll()
  },
  beforeDestroy() {
    this.stopPoll()
  },
  methods: {
    logout() {
      window.localStorage.clear()
      this.$router.push('/').catch(() => {})
    },
    saveNavState(activePath) {
      window.sessionStorage.setItem('activePath', activePath)
    },
    resolvePath(routePath) {
      return routePath || '/hotelRealtimeOrder'
    },
    startPoll() {
      this.stopPoll()
      if (!this.pollEnabled) return
      this.pollTimer = setInterval(() => {
        this.runPollRefresh()
      }, POLL_MS)
    },
    stopPoll() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    },
    onPollToggle(on) {
      if (on) this.startPoll()
      else this.stopPoll()
    },
    /** 将接口中的使用状态规范为 '1'～'5'，无法识别时返回 '' */
    hotelUseStatusNorm(raw) {
      if (raw == null || raw === '') return ''
      const k = String(raw).trim()
      if (/^[1-5]$/.test(k)) return k
      if (raw === '已支付' || raw === '已付款') return '1'
      if (raw === '已完成' || raw === '已入住') return '2'
      if (raw === '已退款') return '3'
      if (raw === '退款中') return '4'
      if (raw === '待确认') return '5'
      return ''
    },
    formatHotelUseStatus(raw) {
      const n = this.hotelUseStatusNorm(raw)
      if (n && HOTEL_USE_STATUS_LABEL[Number(n)]) {
        return HOTEL_USE_STATUS_LABEL[Number(n)]
      }
      if (raw == null || raw === '') return '-'
      return String(raw)
    },
    /** 使用状态标签颜色（与行底色语义一致） */
    hotelUseStatusTagType(row) {
      if (this.isRefundAwaitContact(row)) return 'danger'
      const n = this.hotelUseStatusNorm(row['使用状态'])
      const map = {
        1: 'success',
        2: 'primary',
        3: 'info',
        4: 'warning',
        5: 'warning',
      }
      return map[Number(n)] || 'info'
    },
    hotelUseStatusTagEffect(row) {
      if (this.isRefundAwaitContact(row) || this.isUnconfirmed(row)) return 'dark'
      return 'light'
    },
    hotelUseStatusTagClass(row) {
      if (this.isRefundAwaitContact(row)) return 'hotel-status-tag--refund-contact'
      if (row._pollNew && this.isUnconfirmed(row)) return 'hotel-status-tag--new-pending'
      const n = this.hotelUseStatusNorm(row['使用状态'])
      if (n === '5') return 'hotel-status-tag--pending'
      if (n === '4') return 'hotel-status-tag--refunding'
      return ''
    },
    isHotelRefundedRow(row) {
      return this.hotelUseStatusNorm(row['使用状态']) === '3' || row['使用状态'] === '已退款'
    },
    /** 待确认：仅使用状态为 5 */
    isUnconfirmed(row) {
      return this.hotelUseStatusNorm(row['使用状态']) === '5'
    },
    /** 已退款且待联系：使用状态 3 且 联系状态 0 */
    isRefundAwaitContact(row) {
      if (this.hotelUseStatusNorm(row['使用状态']) !== '3') return false
      const c = row['联系状态']
      return c === 0 || c === '0'
    },
    markNewAndSort(rows) {
      const list = (rows || []).map((r) => ({ ...r }))
      const seen = this.seenOrderIds instanceof Set ? this.seenOrderIds : new Set()
      for (const r of list) {
        const id = r.ID
        if (!this.pollBaselineReady) {
          r._pollNew = false
        } else if (id != null && !seen.has(id) && this.isUnconfirmed(r)) {
          r._pollNew = true
        } else {
          r._pollNew = false
        }
      }
      if (!this.pollBaselineReady) {
        this.pollBaselineReady = true
      }
      const next = new Set(seen)
      list.forEach((r) => {
        if (r.ID != null) next.add(r.ID)
      })
      this.seenOrderIds = next
      const rank = (r) => {
        const red = this.isRefundAwaitContact(r)
        if (red) return 6
        if (r._pollNew) return 4
        if (this.isUnconfirmed(r)) return 2
        return 0
      }
      list.sort((a, b) => {
        const d = rank(b) - rank(a)
        if (d !== 0) return d
        return String(b.购买时间 || '').localeCompare(String(a.购买时间 || ''))
      })
      return list
    },
    tableRowClassName({ row }) {
      if (this.isRefundAwaitContact(row)) return 'row-hotel-refund-contact'
      if (row._pollNew) return 'row-hotel-new-pending'
      if (this.isUnconfirmed(row)) return 'row-hotel-unconfirmed'
      return ''
    },
    buildListParams() {
      const q = { ...this.queryInfo }
      const params = {
        searchStr: q.searchStr,
        currentPage: q.currentPage,
        pageSize: q.pageSize,
        status: q.status,
        orderType: q.orderType,
        orderNo: q.orderNo,
        phone: q.phone,
        area_info: q.area_info,
      }
      if (q.startTime) {
        params.startTime = new DateFormat(new Date(q.startTime)).toString('yyyy-0m-0d')
      }
      if (q.endTime) {
        params.endTime = new DateFormat(new Date(q.endTime)).toString('yyyy-0m-0d')
      }
      if (window.sessionStorage.getItem('isAdmin') === '0') {
        params.userId = window.sessionStorage.getItem('userId')
      }
      return params
    },
    /**
     * 轮询接口专用参数（不传 searchStr、orderType、area_info 等）。
     */
    buildPollParams() {
      const q = { ...this.queryInfo }
      const params = {
        currentPage: q.currentPage,
        pageSize: q.pageSize,
        status: q.status,
        orderNo: q.orderNo,
        phone: q.phone,
      }
      if (q.startTime) {
        params.startTime = new DateFormat(new Date(q.startTime)).toString('yyyy-0m-0d')
      }
      if (q.endTime) {
        params.endTime = new DateFormat(new Date(q.endTime)).toString('yyyy-0m-0d')
      }
      if (window.sessionStorage.getItem('isAdmin') === '0') {
        params.userId = window.sessionStorage.getItem('userId')
      }
      return params
    },
    extractOrderListRows(res) {
      const d = res && res.data
      if (Array.isArray(d)) return d
      if (d && Array.isArray(d.list)) return d.list
      if (d && Array.isArray(d.records)) return d.records
      return []
    },
    filterOrderRows(rows) {
      return (rows || []).filter((v) => {
        const st = v['使用状态']
        return st !== '未付款' && st !== 0 && st !== '0'
      })
    },
    /** 轮询结果按 ID 合并到当前列表，保留详情接口字段，只更新轻量接口返回的字段 */
    mergeOrderListById(current, incoming) {
      if (!incoming || !incoming.length) return current || []
      if (!current || !current.length) return incoming
      const incomingMap = new Map()
      incoming.forEach((r) => {
        if (r.ID != null) incomingMap.set(r.ID, r)
      })
      const seen = new Set()
      const merged = current.map((row) => {
        const patch = incomingMap.get(row.ID)
        if (!patch) return row
        seen.add(row.ID)
        return { ...row, ...patch }
      })
      incoming.forEach((r) => {
        if (r.ID != null && !seen.has(r.ID)) {
          merged.push(r)
          seen.add(r.ID)
        }
      })
      return merged
    },
    applyOrderListResponse(res, silent) {
      if (!silent) this.table_loading = false
      if (res.code !== 200) {
        if (!silent) this.$message.warning(res.msg)
        return
      }
      const raw = this.filterOrderRows(this.extractOrderListRows(res))

      if (silent) {
        // 轻量轮询：无数据或解析失败时不覆盖，避免表格被清空
        if (!raw.length) return
        const merged = this.mergeOrderListById(this.orderList, raw)
        this.orderList = this.markNewAndSort(merged)
        if (typeof res.total === 'number') this.total = res.total
        return
      }

      this.orderList = this.markNewAndSort(raw)
      if (typeof res.total === 'number') this.total = res.total
    },
    /** 定时轮询：固定轻量接口 + 精简参数 */
    runPollRefresh() {
      const area = this.queryInfo.area_info || {}
      const vals = Object.values(area)
      if (!vals.every((v) => v === '') && !vals.every((v) => v !== '')) {
        return
      }
      this.$axios({
        method: 'post',
        url: HOTEL_ORDER_POLL_PATH,
        params: this.buildPollParams(),
      })
        .then((res) => this.applyOrderListResponse(res, true))
        .catch(() => {})
    },
    getOrderList(_e, pageOnly = false, silent = false) {
      if (!pageOnly) {
        this.queryInfo.currentPage = 1
      }
      const area = this.queryInfo.area_info || {}
      const vals = Object.values(area)
      if (!vals.every((v) => v === '') && !vals.every((v) => v !== '')) {
        this.$message.warning('座位查询时请将区域、行号、列号全部填写')
        return
      }
      if (!silent) this.table_loading = true
      this.$axios({
        method: 'post',
        url: HOTEL_ORDER_LIST_PATH,
        params: this.buildListParams(),
      })
        .then((res) => this.applyOrderListResponse(res, silent))
        .catch(() => {
          if (!silent) this.table_loading = false
        })
    },
    handleCurrentChange(newPage) {
      this.queryInfo.currentPage = newPage
      this.getOrderList(null, true)
    },
    hotelOrderPayload(row, extra = {}) {
      const payload = { ID: row.ID, ...extra }
      if (row.订单号 != null && row.订单号 !== '') {
        payload.订单号 = row.订单号
      }
      return payload
    },
    postHotelOrderAction(url, row, extra = {}, successMsg) {
      const that = this
      const loading = that.$loading({
        lock: true,
        text: '处理中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      that
        .$axios({
          method: 'post',
          url,
          data: that.hotelOrderPayload(row, extra),
        })
        .then((res) => {
          loading.close()
          if (res.code === 200) {
            that.$message.success(successMsg)
            that.getOrderList(null, true)
          } else {
            that.$message.warning(res.msg || res.data || '操作失败')
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    hotelOrderConfirm(row) {
      this.$prompt(
        '确认接受该订单？可在下方填写备注（选填）',
        '订单确认',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
          inputPlaceholder: '备注（选填）',
        }
      )
        .then(({ value }) => {
          const FailReason = (value || '').trim()
          this.postHotelOrderAction(
            HOTEL_ORDER_UPDATE_STATUS_URL,
            row,
            { useStatus: 1, FailReason },
            '确认成功'
          )
        })
        .catch(() => {})
    },
    hotelOrderAcknowledge(row) {
      this.$prompt(
        '确认已知晓该笔退款？可在下方填写备注（选填）',
        '知晓',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'info',
          inputPlaceholder: '备注（选填）',
        }
      )
        .then(({ value }) => {
          const FailReason = (value || '').trim()
          this.postHotelOrderAction(
            HOTEL_ORDER_UPDATE_STATUS_URL,
            row,
            { contactStatus: 1, FailReason },
            '已记录知晓'
          )
        })
        .catch(() => {})
    },
    hotelOrderRefund(row) {
      this.$prompt(
        '确认发起退款？可在下方填写备注（选填）',
        '退款',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
          inputPlaceholder: '备注（选填）',
        }
      )
        .then(({ value }) => {
          const FailReason = (value || '').trim()
          this.postHotelOrderAction(
            HOTEL_ORDER_UPDATE_STATUS_URL,
            row,
            { useStatus: 3, FailReason },
            '已提交退款'
          )
        })
        .catch(() => {})
    },
    addNote(row) {
      const that = this
      this.$prompt('请输入备注信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(({ value }) => {
          const loading = that.$loading({
            lock: true,
            text: '添加中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          })
          that
            .$axios({
              method: 'post',
              url: '/manager/addOrderNote',
              data: {
                ID: row.ID,
                note: value,
              },
            })
            .then((res) => {
              loading.close()
              if (res.code === 200) {
                that.$message.success('添加成功')
                that.getOrderList(null, true)
              } else {
                that.$message.warning(res.data)
              }
            })
            .catch(() => {
              loading.close()
            })
        })
        .catch(() => {})
    },
  },
  filters: {
    getPayType(typeID, way = '') {
      switch (typeID) {
        case '1':
          return '其他三方支付'
        case '2':
          return '现金支付'
        case '3':
          return '微信支付'
        case '4':
          return '支付宝支付'
        case '5':
          return '银联支付'
        case '6':
          return 'OTA支付'
        case '7':
          return 'VM'
        case '8':
          return '对公汇款'
        case '9':
          return '欠款'
        default:
          return way
      }
    },
  },
}
</script>

<style scoped>
.hotel-realtime-order {
  padding: 8px;
}
.main-card {
  margin-top: 12px;
}
.poll-hint {
  margin-top: 12px;
}
.search-actions {
  margin-top: 12px;
  margin-bottom: 8px;
}
.hotel-order-actions .el-button {
  margin-right: 6px;
  margin-bottom: 4px;
}
/* 使用状态标签：与行底色区分语义一致 */
.hotel-realtime-order >>> .hotel-status-tag--pending.el-tag--warning {
  background-color: #fdf6ec;
  border-color: #f5dab1;
  color: #e6a23c;
}
.hotel-realtime-order >>> .hotel-status-tag--new-pending.el-tag--warning {
  background-color: #e3f2fd;
  border-color: #90caf9;
  color: #1565c0;
}
.hotel-realtime-order >>> .hotel-status-tag--refund-contact.el-tag--danger {
  background-color: #ffebee;
  border-color: #ef9a9a;
  color: #c62828;
}
.hotel-realtime-order >>> .hotel-status-tag--refunding.el-tag--warning {
  background-color: #fff3e0;
  border-color: #ffcc80;
  color: #ef6c00;
}
</style>

<style>
/* 行底色：已退款待联系 / 本轮首次待确认 / 待确认 */
.hotel-realtime-order .el-table .row-hotel-unconfirmed > td {
  background-color: #fff8e1 !important;
}
.hotel-realtime-order .el-table .row-hotel-new-pending > td {
  background-color: #e3f2fd !important;
}
.hotel-realtime-order .el-table .row-hotel-refund-contact > td {
  background-color: #ffcdd2 !important;
}
.home-container {
  height: 100vh;
}
.el-header {
  background-color: #373d41;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  font-size: 24px;
  font-weight: bold;
}
.el-aside {
  background-color: #333744;
}
.el-main {
  background-color: #eaedf1;
}
.el-aside .toggle-button {
  background-color: #4a5064;
  color: #fff;
  height: 30px;
  line-height: 30px;
  text-align: center;
}
</style>
